import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import PageHeader from '../../components/common/PageHeader';

const MontessoriGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    { id: 1, src: 'https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=800&h=600&fit=crop', alt: 'Learning activities' },
    { id: 2, src: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&h=600&fit=crop', alt: 'Classroom' },
    { id: 3, src: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?w=800&h=600&fit=crop', alt: 'Students' },
    { id: 4, src: 'https://images.unsplash.com/photo-1544485779-fa75d0e4abf9?w=800&h=600&fit=crop', alt: 'Playground' },
    { id: 5, src: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=800&h=600&fit=crop', alt: 'Art class' },
    { id: 6, src: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800&h=600&fit=crop', alt: 'Reading time' },
  ];

  return (
    <>
      <PageHeader
        title="Gallery"
        subtitle="Glimpses of life at Stirret Montessori"
        breadcrumbs={[
          { label: 'Our Schools', href: '/our-schools' },
          { label: 'Montessori & Primary', href: '/montessori' },
          { label: 'Gallery' },
        ]}
        backgroundImage="https://images.unsplash.com/photo-1587654780291-39c9404d746b?w=1600&h=400&fit=crop"
      />

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {images.map((image, index) => (
              <motion.div
                key={image.id}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="aspect-square overflow-hidden rounded-xl cursor-pointer group"
                onClick={() => setSelectedImage(image)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <button className="absolute top-4 right-4 text-white/80 hover:text-white p-2">
              <X size={32} />
            </button>
            <motion.img
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="max-w-full max-h-[90vh] object-contain rounded-lg"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default MontessoriGallery;
